module.exports = __webpack_public_path__ + "img/oval-green.22033b55.png";